<span class="small-sidenav">
	<common-side-nav class="common-side-nav" [side]="'right'" #lowStockPanel [isSidePanelToggled]="isSidePanelToggled" [modalName]="heading" panelBodyClass="scrollable-body" tabindex="0">
		<div id="low-stock-wrapper" ngProjectAs="myPanelCover">
			<a class="details-link" aria-label="floor-model-details" (click)="displayPanel()">Learn More</a>
		</div>
		<div class="floor-model-panel-heading" ngProjectAs="myCustomHeader"><img class="panel-header-image" src="assets/image/Important.svg" alt="important">{{ heading }}</div>
		<div ngProjectAs="myCustomBody">
			<div class="floor-model-panel-body">
				<p class="product-options">The product options you have selected have extremely low stock, and may be the floor model.</p>
				<p class="product-options">Floor models will be fully assembled. Please check the product dimensions to ensure you have a vehicle that is large enough to pick up the product.</p>
				<p class="confirm-msg">To confirm the availability of this product, please contact your local store for further information</p>
				<div class="flex-center">
					<a
						hmf-button
						text="FIND A STORE"
						variant="secondary"
						dataEm="PDP_FloorModelFindAStore"
						ariaLabel="floor-model-find-a-store"
						class="store-details-link"
						href="/s/stores"
						target="_blank">FIND A STORE</a>
				</div>
				<div>
					<p class="covid-return-msg"><span class="covid-return-msg-heading">Modified Returns Policy – COVID-19:</span><br/>
						Due to our store closures and the disruption caused by the COVID-19 impact, Dick’s Sporting Goods will extend our returns policy from 60 days to an extended 90 days from the date of purchase to allow flexibility for our customers in returning. This applies to in store and online purchases. View more information about our Returns Policy.
					</p>
				</div>
			</div>
		</div>
	</common-side-nav>
</span>
